import { useState, useCallback } from 'react';
import { validateDateRange } from '../utils/validation';

interface ImportDataOptions {
  source?: 'prod' | 'local'; // prod: RDS, local: 로컬 Docker MySQL
}

interface UseBTDataImportReturn {
  importData: (startDateTime: string, endDateTime: string, tableName: string, options?: ImportDataOptions) => Promise<any>;
  loading: boolean;
  error: string | null;
}

export const useBTDataImport = (): UseBTDataImportReturn => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const importData = useCallback(async (startDateTime: string, endDateTime: string, tableName: string, options?: ImportDataOptions): Promise<any> => {
    setLoading(true);
    setError(null);

    try {
      // 범용 유효성 검사 사용
      const validation = validateDateRange(startDateTime, endDateTime, { allowEqual: false });
      if (!validation.ok) {
        setError(validation.error || '잘못된 날짜/시간 범위입니다.');
        throw new Error(validation.error || '잘못된 날짜/시간 범위입니다.');
      }

      let url = `/mercury-backend/bt/import-data?table=${encodeURIComponent(tableName)}&startDateTime=${encodeURIComponent(startDateTime)}&endDateTime=${encodeURIComponent(endDateTime)}`;
      if (options?.source === 'local') {
        url += '&source=local';
      }
      console.log(`📊 RDS ${tableName} 테이블에서 데이터 임포트 요청:`, url);

      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const result = await response.json();
      console.log(`✅ RDS ${tableName} 테이블에서 데이터 임포트 완료:`, result);
      
      return result;
    } catch (err) {
      const errorMessage = err instanceof Error ? err.message : 'Unknown error occurred';
      setError(errorMessage);
      console.error(`❌ RDS ${tableName} 테이블에서 데이터 임포트 실패:`, err);
      throw err;
    } finally {
      setLoading(false);
    }
  }, []);

  return {
    importData,
    loading,
    error,
  };
};
